import {defineStore} from 'pinia'

export interface ActiveFilters {
  text: string;
  id: string;
  type: FiltersTypes;
  param: any;
}

export enum FiltersTypes {
  DATE = 'date',
  SEARCH = 'search',
  STATUS = 'status',
  CONSUMER = 'consumer',
  CURRENT_PAGE = 'current_page',
}

export const useSearchStore = defineStore('search', {
  state: () => ({
    activeFilters: [] as ActiveFilters[],
  }),
  getters: {
    getParams(): string[] {
      return this.activeFilters.filter((filter) => filter.type !== FiltersTypes.CURRENT_PAGE).map((filter) => filter.param);
    },
    isFiltersEmpty(): boolean {
      return this.activeFilters.length === 0 || (this.activeFilters.length === 1 && undefined !== this.activeFilters.find((filter) => filter.type === FiltersTypes.CURRENT_PAGE));
    },
  },
  actions: {
    addFilter(filter: ActiveFilters): void {
      this.activeFilters.unshift(filter);
    },
    removeFilterType(type: FiltersTypes) {
      const indexes: number[] = [];
      this.activeFilters.forEach((filter, index) => {
        if (filter.type === type) {
          indexes.push(index);
        }
      });

      indexes.reverse().forEach((index) => {
        this.activeFilters.splice(index, 1);
      });
    },
    removeFilterWithId(idToRemove: string): void {
      const index = this.activeFilters.findIndex(({id}) => id == idToRemove);
      this.activeFilters.splice(index, 1);
    },
    resetFilters(): void {
      this.activeFilters = [];
    },
  },
});
